import { render, staticRenderFns } from "./DeptScheduleRule.vue?vue&type=template&id=31119cf2&scoped=true"
import script from "./DeptScheduleRule.vue?vue&type=script&lang=js"
export * from "./DeptScheduleRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31119cf2",
  null
  
)

export default component.exports